import React, { useCallback, useEffect } from 'react';
import { Form, Input, Row, Col, notification } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {
  createThirdPartyAddress,
  TpAddressResponse2,
  updateThirdPartyAddres,
} from 'services/thirdParty';
import ButtonLink from 'components/theme_components/ButtonLink';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { useForm } from 'antd/lib/form/Form';
import Address from 'components/theme_components/ThirdParty/address';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';

export type AddresseModalProps = {
  address?: TpAddressResponse2;
  setVisible: (visible: boolean) => void;
  tpid: number;
  refetch?: () => void;
  form: FormInstance;

};

const AddresseModal = ({
  setVisible,
  address,
  tpid,
  refetch,
  form,
}: AddresseModalProps) => {



  useEffect(() => {
    form.setFieldsValue({
      event: 'tabAddress',
    });
  }, [form]);
  console.log('tabTPChangeAddress', form.getFieldsValue())
  return (
    <Form
      form={form}
      layout="vertical"
    >
      <div style={{ padding: 10 }}>
        <Row gutter={[3, 3]} className='no-border-radius'>
          <FormInput name="adrtype" col md={24} className='btn-modal'     rules={[{
              required: true,
              message: "please enter address Type "
            }]}>
            <ParListSelect parcode="ADRTYPE" className="ut-input-modal" />
          </FormInput>

          <FormInput
            name="tpmainadrstreet1"
            rules={[{
              required: true,
              message: "please enter street 1 "
            }]}
            
            col md={24}
          >
            <Input className="ut-input-modal"
            allowClear
          
            />
          </FormInput>

          <FormInput
            name="tpmainadrstreet2"
            col md={24}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput
            name="tpmainadrstreet3"
            col md={24}
          >
            <Input className="ut-input-modal" />
          </FormInput>


          {/* <FormInput col md={24} name="tpmainadrzipcode" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput col md={24} name="tpmainadrcity" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput col md={24} name="tpmainadrcountry" rules={[{ required: true }]}
          >
            <Input className="ut-input-modal" />
          </FormInput> */}


          <AddressSFS
            form={form}
            codePostalField="tpmainadrzipcode"
            paysField="tpmainadrcountry"
            regionField="tpmainadrregion"
            villeField="tpmainadrcity"
            comcodecodePostalField="tpmainadrzipcodeTP"
            comcodepaysField="tpmainadrcountryTP"
            comcoderegionField="tpmainadrregionTP"
            comcodevilleField="tpmainadrcityTP"
            colU={24}
            hideRegionGlobal
            hideRegion
            Colw={(localStorage.getItem('lancode') === 'FR') ? { span: 10 } : { span: 4 }}
            spanCountry={24}
            spanZip={24}
            spanCity={24}
            cityRequired
            zipcodeRequired
            countryRequired
            className="ut-input-modal"
          />

        </Row>

      </div>

    </Form>
  );
};
const initialValue = {
  adrenddate: '',
  adrstartdate: '',
  adrstatus: '',
  adrstatusdate: '',
  adrtype: '',
  tpadrid: 0,
  tpid: 0,
  tpmainadrcity: '',
  tpmainadrcountry: '',
  tpmainadrregion: '',
  tpmainadrregionglobale: '',
  tpmainadrstreet1: '',
  tpmainadrstreet2: '',
  tpmainadrzipcode: '',
};
export default AddresseModal;
